<template>
  <div id="scene-container" ref="sceneContainer">
    <Gate3dMetadata ref="gateMeta" v-bind:gateName="this.$router.currentRoute.name"/>
  </div>
</template>

<script>
import * as THREE from 'three'
import {
  GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader'
import {
  Audio
} from 'three/src/audio/Audio'
import {
  AudioLoader
} from 'three/src/loaders/AudioLoader'
import {
  AudioListener
} from 'three/src/audio/AudioListener'
import {
  PositionalAudio
} from 'three/src/audio/PositionalAudio'
import Gate3dMetadata from "@/components/Gate3dMetadata";
import {Vector3} from "three";

/*
import Stats from "stats.js";
*/

export default {
  name: "Explore-mobile",
  components: {
    Gate3dMetadata
  },
  data() {
    return {
      container: null,
      scene: null,
      camera: null,
      controls: null,
      renderer: null,
      /*stats: null,*/
      listener: null,
      ambience: null,
      positional: [],
      positionalPaths: [
        '/audio/gates/Explore/Explore_Blue.mp3',
        '/audio/gates/Explore/Explore_Green.mp3',
        '/audio/gates/Explore/Explore_Yellow.mp3',
      ],
      mapObject: null,
      gates: {
        blue: null,
        green: null,
        yellow: null,
        violet: null,
        indigo: null,
        turquoise: null,
        red: null,
        orange: null,
      },
      frustumSize: null,
      gateClickSound: null,
      gateClickPath: '/audio/gates/Explore/Explore_Gate_Click.mp3',
    }
  },
  methods: {

    async init() {
      console.clear()

      // set container
      this.container = this.$refs.sceneContainer



      this.frustumSize = this.setFrustum()
      let aspect = window.innerWidth / window.innerHeight;
      this.camera = new THREE.OrthographicCamera(
          this.frustumSize * aspect / - 2,
          this.frustumSize * aspect / 2,
          this.frustumSize / 2,
          this.frustumSize / -2,
          1, 100 )
      this.camera.position.set( 5, 35, 5 );
      this.camera.lookAt( new THREE.Vector3( 0, 0, 0 ) );


      // create scene
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0xcccccc)
      //this.scene.background = new THREE.Color(0xffffff)

      const skyColor = 0xffffff; // #ffffff
      const groundColor = 0x222222; // #222222
      const intensity = 1.25;
      const ambientLight = new THREE.HemisphereLight(skyColor, groundColor, intensity);
      this.scene.add(ambientLight)

      // create renderer
      this.renderer = new THREE.WebGLRenderer({
        antialias: true
      })
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.gammaFactor = 2.2
      this.renderer.outputEncoding = THREE.sRGBEncoding
      this.renderer.physicallyCorrectLights = true
      this.container.appendChild(this.renderer.domElement)


      // set the mouse & raycaster
      this.mouse = new THREE.Vector2()
      this.raycaster = new THREE.Raycaster();

      // load and add gltf gate cubes to the scene
      this.mapObject = await this.loadGeometryAsync()
      this.scene.add(this.mapObject.scene)
      this.assignGates()

      //audio part
      this.listener = new AudioListener()

      this.camera.add(this.listener)
      await this.loadPlayAmbienceAsync()

      await this.loadPlayPositionalAsync(this.positionalPaths[0], this.gates.blue)
      await this.loadPlayPositionalAsync(this.positionalPaths[1], this.gates.green)
      await this.loadPlayPositionalAsync(this.positionalPaths[2], this.gates.yellow)

      this.addCube(0, 0, -5)
      this.pointTowardsObject(this.camera, this.cube)

      this.fadeAudioVolume(this.ambience, 0, 1, 5)
      this.fadeAudioVolume(this.positional[0], 0, 1.5, 5)
      this.fadeAudioVolume(this.positional[1], 0, 1.5, 5)
      this.fadeAudioVolume(this.positional[2], 0, 1.5, 5)

      await this.loadGateClick()

    },

    pointTowardsObject(objectToLook, lookTarget) {
      const objectPos = new Vector3(lookTarget.position.x, lookTarget.position.y, lookTarget.position.z)
      objectToLook.lookAt(objectPos)
    },

    addCube(zPos, xPos, yPos) {
      //object
      var material = new THREE.MeshLambertMaterial({color: Math.random() * 0xffffff})
      var geometry = new THREE.BoxBufferGeometry(1, 1, 1);
      this.cube = new THREE.Mesh(geometry, material);
      this.cube.position.z = xPos;
      this.cube.position.x = zPos;
      this.cube.position.y = yPos;
      this.cube.castShadow = true;
      this.cube.receiveShadow = false;
      this.scene.add(this.cube);
    },


    render() {
      this.renderer.render(this.scene, this.camera)
    },

    animate() {
      this.renderer.setAnimationLoop(() => {
        this.render()
        /*        this.controls.update()*/
        /*        var delta = this.clock.getDelta()
                this.controls.update(delta)*/
        /*
                this.stats.update()
        */
      })
      this.establishListeners()
    },

    stopAnimating() {
      this.renderer.setAnimationLoop(null);
    },

    establishListeners() {
      window.addEventListener('resize', this.onWindowResize.bind(this), false)
      this.container.addEventListener('click', this.onMouseClick.bind(this), false)
    },

    onWindowResize() {

      this.frustumSize = this.setFrustum()
      let newAspect = window.innerWidth / window.innerHeight;
      this.camera.top = this.frustumSize / 2
      this.camera.bottom = this.frustumSize / -2
      this.camera.left = this.frustumSize  * newAspect / - 2;
      this.camera.right = this.frustumSize * newAspect / 2;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      //console.log(this.frustumSize)
    },

    isLandscape(){
      return window.innerWidth > window.innerHeight
    },

    setFrustum(){
       return this.isLandscape() ? this.frustumSize = 30 : this.frustumSize = 55
    },

    assignGates() {
      this.gates.blue = this.scene.getObjectByName('blue');
      this.gates.green = this.scene.getObjectByName('green');
      this.gates.yellow = this.scene.getObjectByName('yellow');
      this.gates.violet = this.scene.getObjectByName('violet');
      this.gates.indigo = this.scene.getObjectByName('indigo');
      this.gates.turquoise = this.scene.getObjectByName('turquoise');
      this.gates.red = this.scene.getObjectByName('red');
      this.gates.orange = this.scene.getObjectByName('orange');


    },
    onMouseClick(event) {
      this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      this.raycaster.setFromCamera(this.mouse, this.camera);
      let intersects = this.raycaster.intersectObjects(this.scene.children, true);


      if (intersects.length > 0) {

        {
          switch (intersects[0].object) {
            case this.gates.blue:
              this.gateClickSound.play()
              this.$router.push('/explore/blue');
              break;
            case this.gates.green:
              this.gateClickSound.play()
              this.$router.push('/explore/green');
              break;
            case this.gates.yellow:
              this.gateClickSound.play()
              this.$router.push('/explore/yellow');
              break;
            case this.gates.violet:
              this.gateClickSound.play()
              this.$router.push('/explore/violet');
              break;
            case this.gates.indigo:
              this.gateClickSound.play()
              this.$router.push('/explore/indigo');
              break;
            case this.gates.turquoise:
              this.gateClickSound.play()
              this.$router.push('/explore/turquoise');
              break;
            case this.gates.red:
              this.gateClickSound.play()
              this.$router.push('/explore/red');
              break;
            case this.gates.orange:
              this.gateClickSound.play()
              this.$router.push('/explore/orange');
              break;
          }
        }

      }

    },
    loadGeometryAsync: function () {
      return new Promise((resolve) => {
        const loader = new GLTFLoader()
        loader.load(
            '/models/explore.glb',
            model => {
              resolve(model)
            },
            undefined,
            undefined
        )
      })
    },

    loadPlayAmbienceAsync() {
      this.ambience = new Audio(this.listener)
      return new Promise((resolve) => {
        if (!this.ambience.isPlaying) {
          const loader = new AudioLoader()
          loader.load(
              '/audio/gates/Explore/Explore_Static_on_camera.mp3',
              buffer => {
                this.ambience.setBuffer(buffer)
                this.ambience.setLoop(true)
                this.ambience.setVolume(0)
                this.ambience.play()
                resolve(buffer)
              },
              undefined,
              undefined
          )
        }
      })
    },

    loadPlayPositionalAsync(trackPath, targetObject) {
      let tempPositional = new PositionalAudio(this.listener)
      this.positional.push(tempPositional)
      return new Promise((resolve) => {
        const loader = new AudioLoader()
        loader.load(
            trackPath,
            buffer => {
              tempPositional.setBuffer(buffer)
              tempPositional.setLoop(true)
              tempPositional.setVolume(0)
              tempPositional.setRefDistance(10.0)
              tempPositional.play()
              targetObject.add(tempPositional)
              resolve(buffer)
            },
            undefined,
            undefined
        )
      })
    },

    fadeAudioVolume(audioTrack, from, to, overSeconds) {
      let framerate = 20
      let toIncrement = ( ( to - from ) * framerate) / (overSeconds*1000)
      let interval = setInterval(() => {
        let currentValue = parseFloat(audioTrack.getVolume())

        if (currentValue >= to) {
          clearInterval(interval)
        }
        currentValue = (!isNaN(currentValue) ? currentValue + toIncrement: toIncrement)
        audioTrack.setVolume(currentValue)
      }, framerate)
    },

    loadGateClick(){
      this.gateClickSound = new Audio(this.listener)
      return new Promise((resolve) => {
        const loader = new AudioLoader()
        loader.load(
            this.gateClickPath,
            buffer => {
              this.gateClickSound.setBuffer(buffer)
              this.gateClickSound.setLoop(false)
              this.gateClickSound.setVolume(1)
              resolve(buffer)
            },
            undefined,
            undefined
        )
      })
    }



  },
  mounted() {
    this.init().then(() => this.animate())
  },
  beforeDestroy() {
    this.stopAnimating()
    this.ambience.pause()
    for (let i = 0; i < this.positional.length; i++) {
      this.positional[i].pause()
    }
  },

}
</script>

<style scoped>
#scene-container {
  height: 100%;
  overflow: hidden;
  z-index: 96;
}
</style>
